import type { JSX } from 'react';
import { FormField } from '@/components/form';
import { type UnitFormErrors, type UnitFormState } from './unitFormState';

interface UnitPublishSectionProps {
  formState: UnitFormState;
  errors: UnitFormErrors;
  disabled: boolean;
  isUploadingHero: boolean;
  setFormState: React.Dispatch<React.SetStateAction<UnitFormState>>;
  clearFieldError: (field: keyof UnitFormState) => void;
}

export function UnitPublishSection({
  formState,
  errors,
  disabled,
  isUploadingHero,
  setFormState,
  clearFieldError,
}: UnitPublishSectionProps): JSX.Element {
  const publishDisabled = disabled || isUploadingHero;

  return (
    <FormField
      id="unit-publish"
      label="Realtor outreach emails"
      description="Enable outreach emails to subscribed realtors for this unit."
      hint="When enabled, every saved unit change queues an outreach email. This setting does not control public website visibility."
      error={errors.published}
    >
      <label className="flex items-center gap-3 text-sm font-medium text-text-primary">
        <input
          type="checkbox"
          checked={formState.published}
          disabled={publishDisabled}
          onChange={(event) => {
            setFormState((prev) => ({ ...prev, published: event.target.checked }));
            clearFieldError('published');
          }}
          className="h-4 w-4 rounded border-surface-subtle text-brand-primary focus:ring-brand-primary disabled:cursor-not-allowed"
        />
        {formState.published ? 'Outreach emails enabled' : 'Outreach emails disabled'}
      </label>
    </FormField>
  );
}
